
import Vue from 'vue'

export default Vue.extend({
  name: 'PasswordBoxFormGroup',
  props: {
    id: String,
    label: String,
    value: String,
    placeholder: {type: String, default: ''},
    required: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false},
    validate: {type: Boolean, default: false},
    instructions: {type: String, default: ''},
    minLength: {type: Number, default: 6},
  },
  data() {
    return {
      initialValue: '',
      innerValue: '',
      dirty: false,
      passwordVisible: false,
    }
  },
  computed: {
    inputType(): string {
      return this.passwordVisible ? 'text' : 'password'
    },

    toggleIcon(): string {
      return this.passwordVisible ? 'glyphicon-eye-close' : 'glyphicon-eye-open'
    },

    toggleLabel(): string {
      return this.passwordVisible ? 'Hide password' : 'Show password'
    },

    validationFailed(): boolean {
      if (!this.required || !this.validate || !this.dirty) {
        return false
      }
      if (!this.innerValue) {
        return true
      }
      return this.innerValue.length < this.minLength
    },

    helpBlock(): string {
      if (!this.innerValue) {
        return `A value for ${this.label} is required`
      }
      return `${this.label} must be at least ${this.minLength} characters long`
    },
  },
  mounted() {
    this.innerValue = this.value
    this.initialValue = this.value
  },
  watch: {
    value(newValue: string) {
      if (newValue !== this.innerValue) {
        this.innerValue = newValue
        this.initialValue = newValue
      }
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible
    },

    onChange() {
      if (!this.dirty) {
        this.dirty = this.innerValue !== this.value
      }
      this.$emit('input', this.innerValue)
    },
  },
  components: {},
})
